// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__dETEq","required":"Label_required__3sfTQ","textEllipsis":"Label_textEllipsis__3SMZP"};